const error404 = {
  name: 'Erro 404',
  title: '¡Vaya! La página no está disponible’',
  subtitle: 'El enlace que intentas acceder es incorrecto.',
};

export default error404;
